export default __webpack_public_path__ + "static/media/2-2-2.e5804a9a.webp";